import { Typography } from "antd";
import { TextProps } from "antd/lib/typography/Text";

export const BasicText: React.FC<TextProps> = ({ children, ...textProps }) => {
  return <Typography.Text {...textProps}>{children}</Typography.Text>;
};
